export default "//static.tradera.net/touchweb/static/output/images/dhl.f1fde3d3.svg";